import { AbstractControl, ValidatorFn } from "@angular/forms";

const HEX_REGEX = /^#([0-9A-F]{3}){1,2}$/i;

export function hexColor(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    return HEX_REGEX.test(control.value)
      ? null
      : { valueNotHexColor: "Value not a valid Hex Color" };
  };
}
